import { Action, createActions } from 'redux-actions'
import { Immutable as ImmutableGenericsType } from 'seamless-immutable'

import ReducerBuilder from '../../../utils/ReducerBuilder'
import { Payload } from '../../../types'
import { initialState, State as FormValidationState } from './model'

const actionsMap = createActions({
  VALIDATE_FIELDS: (values, url, resolve, reject) => ({
    values,
    url,
    resolve,
    reject,
  }),
  VALIDATE_FIELDS_SUCCESS: data => ({ data }),
  VALIDATE_FIELDS_FAILURE: error => ({ error }),
})

export const actions = actionsMap

type State = ImmutableGenericsType<FormValidationState>

const reducer = new ReducerBuilder(initialState)
  .add(actions.validateFieldsSuccess, (state: State, action: Action<Payload>) => {
    const data: any = action.payload
    return state.merge(data)
  })
  .add(actions.validateFieldsFailure, (state: State, action: Action<Payload>) => {
    const data: any = action.payload
    return state.merge(data)
  })
  .build()

export default reducer
